import {
  SET_EDIT_MATCH_DATA,
  SET_EDIT_MATCH_TICKET_DATA,
} from '../actions/matchActions';

const initialState = {
  match: {},
  seat: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EDIT_MATCH_DATA:
      return {
        match: action.match,
        seat: state.seat,
      };
    case SET_EDIT_MATCH_TICKET_DATA:
      return {
        match: state.match,
        seat: action.seat,
      };
    default:
      return state;
  }
}
